//login
export const LOGIN_REQUEST_PENDING = "LOGIN_REQUEST_PENDING";
export const LOGIN_REQUEST_SUCCESS = "LOGIN_REQUEST_SUCCESS";
export const LOGIN_REQUEST_FAILED = "LOGIN_REQUEST_FAILED";

//signup
export const SIGNUP_REQUEST_PENDING = "SIGNUP_REQUEST_PENDING";
export const SIGNUP_REQUEST_SUCCESS = "SIGNUP_REQUEST_SUCCESS";
export const SIGNUP_REQUEST_FAILED = "SIGNUP_REQUEST_FAILED";

//token
export const TOKEN_REQUEST_PENDING = "TOKEN_REQUEST_PENDING";
export const TOKEN_REQUEST_SUCCESS = "TOKEN_REQUEST_SUCCESS";
export const TOKEN_REQUEST_FAILED = "TOKEN_REQUEST_FAILED";

//new password
export const NEW_PASSWORD_REQUEST_PENDING = "NEW_PASSWORD_REQUEST_PENDING";
export const NEW_PASSWORD_REQUEST_SUCCESS = "NEW_PASSWORD_REQUEST_SUCCESS";
export const NEW_PASSWORD_REQUEST_FAILED = "NEW_PASSWORD_REQUEST_FAILED";

//password reset
export const NO_ACTION = "NO_ACTION";
export const RESET_EMAIL_INPUT_PENDING = "EMAIL_INPUT_PENDING";
export const RESET_EMAIL_INPUT_SUCCESS = "EMAIL_INPUT_SUCCESS";
export const RESET_EMAIL_INPUT_FAILED = "EMAIL_INPUT_FAILED";
export const TOKEN_INPUT_PENDING = "TOKEN_INPUT_PENDING";
export const TOKEN_INPUT_SUCCESS = "TOKEN_INPUT_SUCCESS";
export const TOKEN_INPUT_FAILED = "TOKEN_INPUT_FAILED";
export const RESET_PASSWORD_INPUT_PENDING = "PASSWORD_INPUT_PENDING";
export const RESET_PASSWORD_INPUT_SUCCESS = "PASSWORD_INPUT_SUCCESS";
export const RESET_PASSWORD_INPUT_FAILED = "PASSWORD_INPUT_FAILED";
export const DISPLAY_RESET_EMAIL = "DISPLAY_RESET_EMAIL";
export const DISPLAY_TOKEN = "DISPLAY_TOKEN";
export const DISPLAY_RESET_PASSWORD = "DISPLAY_RESET_PASSWORD";

//
export const AUTHENTICATED = "AUTHENTICATED";
export const UNAUTHENTICATED = "UNAUTHENTICATED";
export const AUTHENTICATION_PENDING = "AUTHENTICATION_PENDING";
export const AUTHENTICATION_FAILURE = "AUTHENTICATION_FAILURE";

//logout
export const LOGOUT = "LOGOUT";
//set props
export const SET_USER = "SET_USER";
export const SET_TOKEN = "SET_TOKEN";
//reset
export const RESET_APP = "RESET_APP";
